import * as angular from 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { HaynesProService } from './haynes-pro.service';

angular.module('app-lite.haynes-pro', [])
.service('haynesProApi', downgradeInjectable(HaynesProService));